import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Button, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useTemplateCreate from '../../../hooks/template/useTemplateCreate';
import OverviewComponent from './components/OverviewComponent';
import { DataPanel } from './create/DataPanel';
import { EditNewTemplate } from './create/EditNewTemplate';

export const CreateTemplate = () => {
  const profile = useSelector((state) => state?.login?.profile);
  const [formError, setFormError] = useState({ name: false, settings: false });
  const [isView, setIsView] = useState(false);
  const [cursorPosition, setCursorPositionProps] = useState({
    to: null,
    from: null,
    editor: null,
  });
  const theme = useTheme();
  const navigate = useNavigate();
  const { createTemplate } = useTemplateCreate();
  const [templateData, setTemplateData] = useState({
    author: profile?._id,
    name: null,
    service: profile?.roles[0]?.service,
    contactTypes: [],
    stores: [],
    language: null,
    subject: null,
    content: null,
    isDraft: true,
    dynamicData: [],
    attachments: [],
    attachmentsSize: 0,
  });

  const handleClose = () => {
    navigate('/dashboard-template');
  };

  const handleCursorPosition = ({ to, from, editor }) => {
    setCursorPositionProps({ to, from, editor });
  };

  const handleSave = () => {
    let missingField = formError;
    if (!templateData?.name || templateData?.name === '') {
      missingField = { ...missingField, name: true };
    } else {
      missingField = { ...missingField, name: false };
    }
    if (
      templateData?.contactTypes === null ||
      templateData?.stores === null ||
      templateData?.language === null
    ) {
      missingField = { ...missingField, settings: true };
    } else {
      missingField = { ...missingField, settings: false };
    }
    if (!missingField?.name && !missingField?.settings) {
      createTemplate(templateData);
      console.log('creating Template', templateData);
      handleClose();
    }
    setFormError(missingField);
  };

  const handleActivateAndSave = () => {
    let missingField = formError;
    if (!templateData?.name || templateData?.name === '') {
      missingField = { ...missingField, name: true };
    } else {
      missingField = { ...missingField, name: false };
    }
    if (
      templateData?.contactTypes === null ||
      templateData?.stores === null ||
      templateData?.language === null
    ) {
      missingField = { ...missingField, settings: true };
    } else {
      missingField = { ...missingField, settings: false };
    }
    if (!missingField?.name && !missingField?.settings) {
      setTemplateData({ ...templateData, isDraft: false });
      createTemplate({ ...templateData, isDraft: false });
      console.log('creating and activate Template', {
        ...templateData,
        isDraft: false,
      });
      handleClose();
    }
    setFormError(missingField);
  };

  const handleAddDynData = (dynData) => {
    const insert = ` {{${dynData?.label}}} `;

    if (
      cursorPosition?.editor &&
      cursorPosition?.from != null &&
      cursorPosition?.to != null
    ) {
      const ok = cursorPosition?.editor.commands.insertContentAt(
        { from: cursorPosition.from, to: cursorPosition.to },
        insert
      );
      if (!ok) {
        cursorPosition?.editor
          .chain()
          .setTextSelection({
            from: cursorPosition.from,
            to: cursorPosition.to,
          })
          .insertContent(insert)
          .run();
      }
    } else if (cursorPosition?.editor) {
      cursorPosition?.editor.chain().focus().insertContent(insert).run();
    } else {
      return;
    }

    const dataList = [...(templateData?.dynamicData || [])];
    if (
      !dataList.some(
        (item) =>
          item?._id?.toString() === dynData._id?.toString() ||
          item?.toString() === dynData._id?.toString()
      )
    ) {
      dataList.push(dynData?._id);
    }
    setTemplateData({
      ...templateData,
      dynamicData: dataList,
    });
  };

  console.log('templateData', templateData?.dynamicData);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 3,
          borderBottom: `4px solid ${theme.palette.borders.main}`,
        }}
      >
        <Typography sx={{ fontWeight: 'bold', fontSize: 24 }}>
          Nouveau Template
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={() => setIsView(true)}
          >
            <VisibilityIcon />
          </Button>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={handleSave}
          >
            Enregistrer
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleActivateAndSave}
          >
            Enregistrer et activer
          </Button>
          <Button
            variant="text"
            color="primary"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon />
          </Button>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <EditNewTemplate
          templateData={templateData}
          setTemplateData={setTemplateData}
          formError={formError}
          onCursorPosition={handleCursorPosition}
        />
        <DataPanel onClick={handleAddDynData} />
      </Box>
      <OverviewComponent
        template={templateData}
        onClose={() => setIsView(false)}
        displayed={isView}
      />
    </>
  );
};
